/**
 * A Mac App Store link that opens the App Store app on a Mac (owner 2026-10-14). The page keeps the web link
 * (apps.apple.com) as its href, for every other device, for search engines and for "copy link"; a click on a Mac
 * goes to the same listing through the macappstore:// scheme instead, so the App Store app opens at once in any
 * browser (Safari does that by itself; Chrome and the rest would show Apple's web page first).
 */

/** A Mac: macOS in the user agent, and not an iPad, whose Safari also calls itself "Macintosh" but has a touch screen. */
export function isMac(): boolean {
  if ( typeof navigator === 'undefined' ) return false;
  const ua = navigator.userAgent || '';
  return /Macintosh|Mac OS X/.test( ua ) && !( ( navigator.maxTouchPoints || 0 ) > 1 );
}

/** https://apps.apple.com/app/… -> macappstore://apps.apple.com/app/… */
export function macAppStoreUrl( url: string ): string {
  return url.replace( /^https:\/\/apps\.apple\.com\//, 'macappstore://apps.apple.com/' );
}

/** On a Mac, opens the listing in the App Store app instead of following the web link; elsewhere does nothing. */
export function openInMacAppStore( event: Event | undefined, url: string ): void {
  if ( !isMac() || !/^https:\/\/apps\.apple\.com\//.test( url ) ) return;
  event?.preventDefault();
  window.location.href = macAppStoreUrl( url );
}
